









































import Vue from 'vue';

import Component from 'vue-class-component';

@Component({
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
})
export default class ReUnsubscribe extends Vue {
  public reUnsubscribe(): void {
    this.$emit('click', { reClick: true });
  }
}

